import { Injectable } from '@angular/core';
import { Observable, of as observableOf } from 'rxjs';

import { RegistrationEdge } from '@app/registration/graph/graph-navigation.service';
import { MarkRegAsyncNode } from '@app/registration/graph/nodes/mark-reg-async.node';

@Injectable({
  providedIn: 'root',
})
export class MfaToMarkRegAsyncEdge implements RegistrationEdge {
  nextNode = MarkRegAsyncNode;

  shouldNavigate$(): Observable<boolean> {
    return observableOf(true);
  }
}
